<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet.gridlayer.googlemutant'

import {findRealParent, propsBinder} from 'vue2-leaflet'

const props = {
  options: {
    type: Object,
    default() {
      return {};
    },
  },
  lang: {
    type: String,
    default: null
  },
  region: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'roadmap'
  },
  layer: {
    type: String,
    default: null
  },
  visible: {
    type: Boolean,
    default: true,
  },
};

export default {
  props,
  data() {
    return {
      ready: false,
    };
  },
  mounted() {
    this.initializeLayer(this.type, this.layer)
  },
  beforeDestroy() {
    this.parentContainer.removeLayer(this);
  },
  watch: {
    type: function (ntype) {
      this.parentContainer.removeLayer(this);
      this.initializeLayer(ntype, this.layer)
    },
    layer: function (nlayer) {
      this.parentContainer.removeLayer(this);
      this.initializeLayer(this.type, nlayer)
    }
  },
  methods: {
    initializeLayer(type, layer) {
      this.options["type"] = type
      this.mapObject = L.gridLayer.googleMutant(this.options);
      L.DomEvent.on(this.mapObject, this.$listeners);
      propsBinder(this, this.mapObject, props);

      this.ready = true;
      this.parentContainer = findRealParent(this.$parent);
      this.parentContainer.addLayer(this, !this.visible);
      if (layer !== null)
        this.mapObject.addGoogleLayer(layer)
    },
    addLayer(layer, alreadyAdded) {
      if (!alreadyAdded) {
        this.mapObject.addLayer(layer.mapObject);
      }
    },
    removeLayer(layer, alreadyRemoved) {
      if (!alreadyRemoved) {
        this.mapObject.removeLayer(layer.mapObject);
      }
    },
  },
};
</script>
